import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "./styles/design-tokens.css";
import { initSentry } from "@/lib/sentry";
import { initPostHog } from "@/lib/posthog";

initSentry();
initPostHog();

createRoot(document.getElementById("root")!).render(<App />);
